import styled from 'styled-components'
import { ThemedButton } from '../../shared_components/ThemedButton'
import { Box } from '../../shared_components/UI/Box'
import { Link } from 'react-router-dom'

const Text = styled.h2`
  font-style: normal;
  font-family: 'Space Grotesk';
  font-weight: 800;
  font-size: 32px;
  letter-spacing: 4.8px;
  text-align: center;
  z-index: 10;
  transition: 0s;
  text-transform: uppercase;
  flex: 0;
  height: auto;
  padding: 0;
  max-width: 800px;
`

const Container = styled(Box)`
  min-height: 600px;
  a {
    flex: 0;
  }
`

const Geoblocked = ({ country }: { country: string }) => {
  return (
    <Container dc c g={32} fu>
      <Text>Sorry, but this fundraise is not available in {country}</Text>
      <Link to="/">
        <ThemedButton $styleType="primary">Back to home</ThemedButton>
      </Link>
    </Container>
  )
}

export default Geoblocked
